<template>
  <div class="client-card border" v-if="object">
    <div class="client-card__panel">
      <i class="ki-duotone ki-cube-3 fs-3x text-primary">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <div class="ms-4">
        <div class="fs-6 fw-bolder text-gray-700">{{ isImmovable ? 'Недвижимое имущество' : 'Движимое имущество' }}</div>
        <div class="fs-8 text-gray-400">
          Страховая сумма: <span class="text-primary opacity-75">{{ parseFloat(object.amount).toLocaleString('ru-RU', { minimumFractionDigits: 2 }) }} тг.</span>
        </div>
      </div>
      <div class="card_change">
        <slot name="change"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ObjectOneCCard',
  props: {
    object: {
      type: Object,
      default: null
    },
    isImmovable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>